/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `min` - min
 * * `avg` - avg
 * * `max` - max
 * @export
 */
export const CostTypeEnum = {
  MIN: "min",
  AVG: "avg",
  MAX: "max",
} as const;
export type CostTypeEnum = (typeof CostTypeEnum)[keyof typeof CostTypeEnum];

export function instanceOfCostTypeEnum(value: any): boolean {
  for (const key in CostTypeEnum) {
    if (Object.prototype.hasOwnProperty.call(CostTypeEnum, key)) {
      if (CostTypeEnum[key as keyof typeof CostTypeEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function CostTypeEnumFromJSON(json: any): CostTypeEnum {
  return CostTypeEnumFromJSONTyped(json, false);
}

export function CostTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): CostTypeEnum {
  return json as CostTypeEnum;
}

export function CostTypeEnumToJSON(value?: CostTypeEnum | null): any {
  return value as any;
}

export function CostTypeEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): CostTypeEnum {
  return value as CostTypeEnum;
}
